import { ExperienceProjectType, ExperienceProjectTypeOptions } from '@apply/constants';

export const formatProjectType = (experienceProjectTypeId: ExperienceProjectType) => {
    const option = ExperienceProjectTypeOptions.find((a) => a.id === experienceProjectTypeId);
    return <span>{option?.name ?? 'Unknown'}</span>;
};
